import angular from 'angular';
import categoryProductsComponent from './category-products.component';
import CategoryProductsService from './category-products.service';
import categoryProductsConfig from './category-products.config';

let categoryProductsModule = angular.module('categoryProducts',[])
  .component('categoryProducts', categoryProductsComponent)
  .service('CategoryProductsService', CategoryProductsService)
  .config(categoryProductsConfig);

export default categoryProductsModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/category/category-products/category-products.js
 **/